/**
 * Full-page loading screen with the animated TrainLoop loop icon.
 * Use for route/app-level loading states (auth, org, team resolution) —
 * not for inline button spinners or content skeletons.
 */
export default function LoadingScreen({ label }: { label?: string }): React.JSX.Element {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-background">
      {/* Black variant only — app is light-mode only; add _White.svg swap if dark mode ships */}
      <img
        src="/TrainLoop_Loading_Black.svg"
        alt=""
        aria-hidden="true"
        className="h-16 w-16"
      />
      <p className="text-muted-foreground" role="status">
        {label ?? 'Loading...'}
      </p>
    </div>
  )
}

/**
 * In-content loading state for whole-panel/page-body loads where a skeleton
 * would just be a shapeless blob. Keep real skeletons where they mirror the
 * incoming content (table rows, charts).
 */
export function LoadingPanel({ label }: { label?: string }): React.JSX.Element {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-24"
      role="status"
      aria-label="Loading"
    >
      <img
        src="/TrainLoop_Loading_Black.svg"
        alt=""
        aria-hidden="true"
        className="h-10 w-10"
      />
      {label !== undefined && (
        <p className="text-sm text-muted-foreground">{label}</p>
      )}
    </div>
  )
}
